import { DocumentSupportModel } from './document-support.model';

export class DocumentSupportDetailModel {
  documentSupportDetailId: number = 0;
  documentSupportId: number = 0;
  documentSupport: DocumentSupportModel | null = null;
  articleId: number = 0;
  quantity: number = 0;
  unitValue: number = 0;
  creditNotesValue: number = 0;
  totalValue: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
